import { BasicConfig } from '@shared/models/basic-config.interface';
import { ExperienceFilter } from '@shared/models/experience-filter';

export abstract class JobConfig extends BasicConfig {
  privileges: {
    greenhouse: {
      prospect: string;
    };
    assigned: {
      // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: string;
      jobs: string;
    };
    associate: {
      candidate_to_job: string;
      jobs_to_candidate: string;
    };
    job: {
      view: string;
      create: string;
      edit: string;
      notes: string;
      files: string;
      publish: string;
      teamMembers: {
        view: string;
        edit: string;
      };
      budgetInfo: string;
    };
    hiringManager: string;
  };
  filter: {
    experience: ExperienceFilter;
  };
}

export type JobPrivileges = JobConfig['privileges'];
